import { initializeApp } from "firebase/app";
const firebaseConfig = {
    apiKey: "AIzaSyBl1do3wg3-YfDl-8OW5TcRyu9NydNCDdc",
    authDomain: "texpideaadmin.firebaseapp.com",
    projectId: "texpideaadmin",
    storageBucket: "texpideaadmin.appspot.com",
    messagingSenderId: "477258618013",
    appId: "1:477258618013:web:9dcdc61b25129f52ed7074",
    measurementId: "G-WS8XZY8BNB"
  };
  const app = initializeApp(firebaseConfig);

export default app;